export const API_URL = process.env.REACT_APP_BACKEND_URL;


export const NEW_BACKEND_URL = process.env.REACT_APP_NEW_BACKEND_URL;

export const ACCESS_TOKEN=process.env.REACT_APP_ACCESS_TOKEN